"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const defineAppConfig_1 = require("../defineAppConfig");
exports.default = (0, defineAppConfig_1.defineAppConfig)({
    appName: '斉藤麻里 / SaitoMari',
    organizationId: '8E4lL4s5D6wmp1QJhsew',
    applicationKey: 'maritree',
    applicationType: 'standalone',
    artistId: 'Zq4O19dGixSzWdcY3qigDFQvlJ92',
    version: '1.0.0',
    ios: {
        bundleId: 'com.utoniq.maritree',
        appId: '',
    },
    android: {
        bundleId: 'com.utoniq.maritree',
    },
    deeplinkUrl: 'https://maritree.utoniq.com',
    helpUrl: 'https://help.utoniq.com/ja/collections/3564140',
    deeplinkProd: 'maritree.utoniq.com',
    custom: {
        modules: {
            membership: true,
            liveStream: true,
            item: true,
            store: true,
            mission: true,
            cart: true,
            konbiniPayment: true,
        },
        tutorials: [
            'images/tutorial/Tutorial01.jpg',
            'images/tutorial/Tutorial02.jpg',
            'images/tutorial/Tutorial03.jpg',
            'images/tutorial/Tutorial04.jpg',
        ],
        globalTabs: [],
        artistTabs: ['home', 'collections', 'posts', 'notifications', 'myProfile'],
    },
});
